import React from "react";

export type TagColour = "red" | "blue" | "grey" | "yellow" | "green" | "orange" | "green-200";

interface TagProps {
  className?: string;
  colour?: TagColour;
  dataTestId?: string;
  size?: string;
  text?: string | React.ReactNode;
}

export const Tag = ({ className, colour = "blue", dataTestId = "", size, text }: TagProps) => (
  <div className={`tag standard ${colour} ${className ?? ""} ${size ?? ""}`} data-testid={dataTestId}>
    {text}
  </div>
);
